export default "__VITE_ASSET__CWFqfD5S__"